import { render, staticRenderFns } from "./SelectNotetakingGuide.vue?vue&type=template&id=5e3cb7d5&scoped=true"
import script from "./SelectNotetakingGuide.vue?vue&type=script&lang=js"
export * from "./SelectNotetakingGuide.vue?vue&type=script&lang=js"
import style0 from "./SelectNotetakingGuide.vue?vue&type=style&index=0&id=5e3cb7d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3cb7d5",
  null
  
)

export default component.exports